export default __webpack_public_path__ + "static/Checklist-680e6f3f31904d4870920e58e85d10be.pdf";